import { Button, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';

interface ArenaEditActionsProps {
  canEdit: boolean;
  editing: boolean;
  saving: boolean;
  saveDisabled?: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
}

const ArenaEditActions: React.FC<ArenaEditActionsProps> = ({
  canEdit,
  editing,
  saving,
  saveDisabled = false,
  onEdit,
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation();

  if (!canEdit) {
    return null;
  }

  if (!editing) {
    return (
      <Button onClick={onEdit} data-testid="arena-edit-button">
        {t(i18nKeys.general.edit)}
      </Button>
    );
  }

  return (
    <SpaceBetween size="xs" direction="horizontal">
      <Button variant="link" onClick={onCancel} disabled={saving} data-testid="arena-cancel-button">
        {t(i18nKeys.general.cancel)}
      </Button>
      <Button
        variant="primary"
        onClick={onSave}
        loading={saving}
        disabled={saveDisabled}
        data-testid="arena-save-button"
      >
        {t(i18nKeys.general.save)}
      </Button>
    </SpaceBetween>
  );
};

export default ArenaEditActions;
